var _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSixblocksLogoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logo_footer_business_partner_web",
    "data-name": "Logo footer business partner web",
    xmlns: "http://www.w3.org/2000/svg",
    width: 153.898,
    height: 70.148,
    viewBox: "0 0 153.898 70.148",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(53.622 12.597)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M93.542,33.9l-.219,3.4-.082.022a4.227,4.227,0,0,0-2.912-1.664,6.5,6.5,0,0,0-1.243-.127,4.265,4.265,0,0,0-1.016.1,2.336,2.336,0,0,0-.723.3,1.253,1.253,0,0,0-.635,1.086,1.578,1.578,0,0,0,.555,1.318,4.951,4.951,0,0,0,2.3.746,11.78,11.78,0,0,1,2.578.583,5.011,5.011,0,0,1,1.6.936,3.842,3.842,0,0,1,1.179,3.005A4.53,4.53,0,0,1,93,47.531a6.909,6.909,0,0,1-4.137,1.18,10.9,10.9,0,0,1-3.977-.763,5.563,5.563,0,0,1-1.132-.589l.127-3.861.047-.035a5.008,5.008,0,0,0,4.7,2.473q2.324,0,3.075-1.122a1.5,1.5,0,0,0,.255-.849,1.749,1.749,0,0,0-.151-.774,1.311,1.311,0,0,0-.5-.526,5.219,5.219,0,0,0-2.254-.59,9.131,9.131,0,0,1-2.589-.566,4.771,4.771,0,0,1-1.606-1.029,4.236,4.236,0,0,1-1.087-3.1,4.222,4.222,0,0,1,1.444-3.328,5.772,5.772,0,0,1,3.958-1.3A8.2,8.2,0,0,1,93.542,33.9Z",
    transform: "translate(-83.752 -29.501)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M99.875,31.752a22.449,22.449,0,0,1,2.312-3.051l2.981,2.346q-.6.74-1.109,1.444L103,34.007Zm3.732,14.574a10.81,10.81,0,0,0,.047,1.3h-2.935V35.544h2.888Z",
    transform: "translate(-86.93 -28.701)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M110.819,43.141l-4.092-5.918h3.616l2.139,3.687,2.312-3.687h3.363a3.407,3.407,0,0,0-.254.336l-3.769,5.374,4.277,6.369h-3.583l-2.312-3.919L110.229,49.3h-3.618Z",
    transform: "translate(-88.257 -30.38)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M133.5,47.294a6.056,6.056,0,0,1-2.2,1.046,12.783,12.783,0,0,1-3.323.37,26.305,26.305,0,0,1-4.19-.358V33.119a25.092,25.092,0,0,1,3.889-.359,9.8,9.8,0,0,1,2.705.312,5.067,5.067,0,0,1,1.728.844,3.231,3.231,0,0,1,1.318,2.665,3.5,3.5,0,0,1-1.19,2.71,3.857,3.857,0,0,1,2.184,1.665,4.4,4.4,0,0,1,.7,2.432,6.06,6.06,0,0,1-.385,2.284A3.981,3.981,0,0,1,133.5,47.294Zm-6.652-8.431a7.612,7.612,0,0,0,1.213.08,3.211,3.211,0,0,0,1.2-.189,1.7,1.7,0,0,0,1.139-1.8q0-1.767-2.081-1.768a13.229,13.229,0,0,0-1.468.069Zm1.71,2.473a10.171,10.171,0,0,0-1.71.128v4.542a6.784,6.784,0,0,0,1.7.208A5.2,5.2,0,0,0,130.112,46a3.481,3.481,0,0,0,1.137-.584,2.4,2.4,0,0,0,.936-1.942Q132.186,41.337,128.556,41.336Z",
    transform: "translate(-91.641 -29.501)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M143.285,46.743a10.815,10.815,0,0,0,.047,1.3h-2.938V30.816h2.891Z",
    transform: "translate(-94.915 -29.118)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M146.945,43.269a6.922,6.922,0,0,1,.433-2.433,5.928,5.928,0,0,1,5.832-3.9,5.809,5.809,0,0,1,4.46,1.768,6.141,6.141,0,0,1,1.583,4.381,6.321,6.321,0,0,1-1.629,4.46,6.587,6.587,0,0,1-9.164.035A6.18,6.18,0,0,1,146.945,43.269Zm2.809-.07a4.176,4.176,0,0,0,.243,1.41,3.324,3.324,0,0,0,.693,1.168,3.25,3.25,0,0,0,2.52,1.052,2.772,2.772,0,0,0,2.277-1.029,3.982,3.982,0,0,0,.808-2.59,3.933,3.933,0,0,0-.831-2.612,3.013,3.013,0,0,0-2.438-1.063,2.958,2.958,0,0,0-2.463,1.132A4,4,0,0,0,149.754,43.2Z",
    transform: "translate(-96.206 -30.324)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M174.537,48.123a5.545,5.545,0,0,1-4.057,1.294,6.07,6.07,0,0,1-4.382-1.629,5.807,5.807,0,0,1-1.721-4.392,6.148,6.148,0,0,1,6.519-6.46,6.457,6.457,0,0,1,3.583.936l-.462,2.958-.082-.011a2.674,2.674,0,0,0-1.167-.878,6,6,0,0,0-1.988-.347,3.9,3.9,0,0,0-1.561.255,2.848,2.848,0,0,0-.971.7A3.587,3.587,0,0,0,167.439,43q0,2.705,1.872,3.536a3.431,3.431,0,0,0,1.371.278,5.5,5.5,0,0,0,1.26-.127,4.521,4.521,0,0,0,.977-.347,2.782,2.782,0,0,0,1.27-1.074l.081.034Z",
    transform: "translate(-99.641 -30.324)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M183.086,46.683a10.907,10.907,0,0,0,.08,1.526h-2.912V31.681h2.832V41.806l5.282-5.675H191.8l-4.554,4.8,2.6,3.548q.844,1.342,1.272,1.966l.764,1.074c.23.3.424.532.577.695h-1.825a7.666,7.666,0,0,0-1.746.172l-3.607-5.27-2.2,2.334Z",
    transform: "translate(-102.771 -29.288)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M201.071,49.417a8.387,8.387,0,0,1-4.911-1.19q.024-.346.069-.785l.105-.833q.092-.819.114-1.022a1.234,1.234,0,0,1,.036-.22c.006-.01.069.051.184.185a2.78,2.78,0,0,0,.66.491,5.966,5.966,0,0,0,1.12.509,8.727,8.727,0,0,0,2.866.475q2,0,2-1.33a.678.678,0,0,0-.381-.635,6.537,6.537,0,0,0-2.006-.527,9,9,0,0,1-2.168-.526,4.637,4.637,0,0,1-1.375-.832,3.118,3.118,0,0,1-.981-2.392,3.335,3.335,0,0,1,1.386-2.833,7.2,7.2,0,0,1,7.906.347c-.053.2-.112.393-.173.579-.177.507-.309.874-.393,1.1l-.265.682c-.016.061-.026.092-.035.092a.994.994,0,0,1-.185-.242,3.719,3.719,0,0,0-2.267-1.11,5.038,5.038,0,0,0-.971-.092q-2.1,0-2.1,1.271a.728.728,0,0,0,.439.671,6.955,6.955,0,0,0,2.247.646,7.921,7.921,0,0,1,2.167.562,3.749,3.749,0,0,1,1.19.849,3.385,3.385,0,0,1,.833,2.393,3.2,3.2,0,0,1-1.306,2.647A6.005,6.005,0,0,1,201.071,49.417Z",
    transform: "translate(-105.905 -30.324)",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(52.998 35.896)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M87.886,78.434a8.387,8.387,0,0,1-4.911-1.19c.015-.232.039-.495.068-.786l.105-.833c.062-.548.1-.887.115-1.023a1.167,1.167,0,0,1,.036-.22c.006-.011.069.051.183.185a2.809,2.809,0,0,0,.661.491,6.06,6.06,0,0,0,1.119.508,8.752,8.752,0,0,0,2.867.474q2,0,2-1.329a.682.682,0,0,0-.381-.637,6.552,6.552,0,0,0-2.006-.525,8.951,8.951,0,0,1-2.167-.526,4.66,4.66,0,0,1-1.375-.832,3.117,3.117,0,0,1-.982-2.394,3.332,3.332,0,0,1,1.387-2.83,6.272,6.272,0,0,1,3.8-1.018,6.349,6.349,0,0,1,4.1,1.364q-.081.3-.173.577-.266.764-.393,1.1l-.265.682c-.016.063-.027.092-.035.092a1,1,0,0,1-.185-.242,3.718,3.718,0,0,0-2.266-1.109,5.044,5.044,0,0,0-.971-.093q-2.1,0-2.1,1.272a.723.723,0,0,0,.439.67,6.966,6.966,0,0,0,2.247.648,7.9,7.9,0,0,1,2.167.56,3.759,3.759,0,0,1,1.191.85A3.388,3.388,0,0,1,93,74.713a3.2,3.2,0,0,1-1.306,2.646A6,6,0,0,1,87.886,78.434Z",
    transform: "translate(-82.975 -59.34)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M97.7,72.285a6.912,6.912,0,0,1,.433-2.433,5.921,5.921,0,0,1,5.831-3.9,5.814,5.814,0,0,1,4.462,1.769,6.144,6.144,0,0,1,1.583,4.38,6.337,6.337,0,0,1-1.629,4.462,6.589,6.589,0,0,1-9.166.035A6.183,6.183,0,0,1,97.7,72.285Zm2.807-.069a4.193,4.193,0,0,0,.243,1.41,3.34,3.34,0,0,0,.693,1.167,3.25,3.25,0,0,0,2.52,1.052,2.773,2.773,0,0,0,2.277-1.029,4.529,4.529,0,0,0-.023-5.2,3.01,3.01,0,0,0-2.439-1.064,2.956,2.956,0,0,0-2.462,1.134A4,4,0,0,0,100.508,72.216Z",
    transform: "translate(-85.877 -59.34)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M118.656,75.761a10.894,10.894,0,0,0,.046,1.294h-2.935V59.834h2.89Z",
    transform: "translate(-89.437 -58.135)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M130.6,77.255a4.96,4.96,0,0,1-3.225,1.224,3.634,3.634,0,0,1-2.935-1.261,5.107,5.107,0,0,1-1.016-3.363V69.268a17.678,17.678,0,0,0-.1-2.652,3.626,3.626,0,0,0-.144-.434c.354.031.724.046,1.108.046h.96q.381,0,1.005-.035v6.693q0,2.381,1.3,2.762a3.04,3.04,0,0,0,.854.116,2.72,2.72,0,0,0,2.2-.994V66.228h2.866v10.6a8.433,8.433,0,0,0,.092,1.478H130.6Z",
    transform: "translate(-90.899 -59.386)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M145.7,74.966a2.357,2.357,0,0,0,2.045-.775h.092l.035,2.682a3.613,3.613,0,0,1-2.1.752,7.868,7.868,0,0,1-1.035.058,4.389,4.389,0,0,1-1.339-.232,2.931,2.931,0,0,1-1.232-.752,4.647,4.647,0,0,1-1.052-3.362V68.089H139.37c-.008-.224-.011-.451-.011-.682v-1.78a.632.632,0,0,1,.011-.2h1.746V62.137h2.832v3.294h3.177v2.659h-3.177V72.8q0,1.815,1.005,2.069A2.765,2.765,0,0,0,145.7,74.966Z",
    transform: "translate(-94.087 -58.589)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M151.566,60.769a22.4,22.4,0,0,1,2.312-3.051l2.981,2.346q-.6.74-1.109,1.445l-1.063,1.513ZM155.3,75.344a10.822,10.822,0,0,0,.047,1.294H152.41V64.56H155.3Z",
    transform: "translate(-96.493 -57.718)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M159.182,72.285a6.894,6.894,0,0,1,.433-2.433,5.921,5.921,0,0,1,5.83-3.9,5.812,5.812,0,0,1,4.462,1.769,6.145,6.145,0,0,1,1.584,4.38,6.334,6.334,0,0,1-1.63,4.462,6.589,6.589,0,0,1-9.166.035A6.187,6.187,0,0,1,159.182,72.285Zm2.807-.069a4.192,4.192,0,0,0,.243,1.41,3.355,3.355,0,0,0,.694,1.167,3.248,3.248,0,0,0,2.52,1.052,2.771,2.771,0,0,0,2.277-1.029,4.529,4.529,0,0,0-.023-5.2,3.008,3.008,0,0,0-2.438-1.064,2.958,2.958,0,0,0-2.463,1.134A4,4,0,0,0,161.989,72.216Z",
    transform: "translate(-97.994 -59.34)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M180.6,76.782a8.429,8.429,0,0,0,.092,1.478h-2.9V66.182H180.6v1.029a5.038,5.038,0,0,1,3.259-1.26,3.836,3.836,0,0,1,3.028,1.283,4.945,4.945,0,0,1,1.134,3.4v6.485a5.553,5.553,0,0,0,.092,1.143h-2.9V72q0-3.387-2.057-3.387a3,3,0,0,0-2.555,1.572Z",
    transform: "translate(-101.662 -59.34)",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M18.13,36.936H29.509V25.555H40.891V14.175H18.13Z",
    transform: "translate(-17.197 -13.242)",
    fill: "#28b6ea",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M52.269,82.248V93.629H18.13V70.868H29.51v11.38Z",
    transform: "translate(-17.197 -24.414)",
    fill: "#86bc44",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M40.89,53.9v22.76H29.51V65.282H18.13V42.521H29.51V53.9Z",
    transform: "translate(-17.197 -18.828)",
    fill: "#5b3061",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M46.476,79.455V56.694h11.38V68.076H69.235v22.76H57.856V79.455Z",
    transform: "translate(-22.783 -21.621)",
    fill: "#b44784",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M69.236,62.489V28.349H57.855V39.728H46.477V51.109H57.855V62.489Z",
    transform: "translate(-22.784 -16.035)",
    fill: "#ca1d2a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M32.3,48.317H43.682V36.936H55.064V25.556h11.38V14.175H43.682V25.556H32.3Z",
    transform: "translate(-19.99 -13.242)",
    fill: "#f98526",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M28.805,83.41h0V72.03H19.292V92.925H51.565V83.41H28.805Z",
    transform: "translate(-17.426 -24.643)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M57.151,69.237V57.856H47.639V78.751h11.38V90.132h9.513V69.238H57.151Z",
    transform: "translate(-23.013 -21.85)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M30.672,75.957h9.514V55.065H28.805V43.684H19.292V64.577h11.38Z",
    transform: "translate(-17.426 -19.057)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M28.8,24.851h11.38V15.337H19.292V36.232H28.8Z",
    transform: "translate(-17.426 -13.471)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M59.019,40.892H47.639V50.4h11.38V61.785h9.514V29.511H59.019Z",
    transform: "translate(-23.013 -16.264)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M44.846,26.717H33.465V47.611h9.513V36.232h0v0H54.358V24.851H65.739V15.337H44.846Z",
    transform: "translate(-20.219 -13.471)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M39.727,13.013H16.968V83.161H64.352V60.4h0V26.26h0V13.013H39.727ZM18.834,14.879H39.727v9.513H28.347V35.773H18.834Zm0,43.654V37.64h9.514V49.021h11.38V69.914H30.214V58.534H18.834ZM51.107,81.3H18.834V60.4h9.514V71.78H51.107ZM62.486,60.4V81.3H52.973V69.914H41.594v-20.9h9.512V60.4h11.38Zm0-1.867H52.973V47.153H41.594V37.641H52.975V26.26h9.512Zm0-43.655v9.514H51.107V35.772H39.728v0h0V47.153H30.214V26.26H41.6V14.879Z",
    transform: "translate(-16.968 -13.013)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSixblocksLogoWhite);
export default __webpack_public_path__ + "static/media/sixblocks-logo-white.c1f93bf83cf2fe42137f9e93cc4dc30a.svg";
export { ForwardRef as ReactComponent };